import React from 'react';

export const HotelIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.17648 2.2383C1.97286 2.46525 1.96155 2.79433 1.90499 9.36454L1.84843 16.2411L1.42987 16.2752L1 16.3092V17.1603V18H9.8802H18.7604V17.1489V16.2979H18.3079H17.8554V11.8156V7.34468L16.9844 7.31064L16.102 7.2766L16.0454 4.81419C15.9889 2.52199 15.9776 2.34043 15.7626 2.18156C15.5703 2.03404 14.6427 2.01135 8.9639 2C2.42536 2 2.39142 2 2.17648 2.2383ZM14.3486 5.51773V7.33333H11.6902H9.03177L9.00914 11.7816L8.97521 16.2411L6.29418 16.2752L3.60184 16.2979V10V3.70213H8.97521H14.3486V5.51773ZM16.102 12.6667V16.2411L15.2309 16.2752L14.3486 16.3092L14.3259 13.6085L14.292 10.9078L13.421 10.8738L12.5386 10.8397V13.5745V16.2979H11.6336H10.7286V12.7461C10.7286 10.783 10.7626 9.14894 10.8078 9.10355C10.8531 9.0695 12.0522 9.04681 13.4888 9.05816L16.102 9.0922V12.6667Z"
      fill="currentColor"
    />
    <path
      d="M5.41406 6.4246V7.34375L6.29643 7.30971L7.16748 7.27566L7.20141 6.39056L7.23535 5.5168H6.31905H5.41406V6.4246Z"
      fill="currentColor"
    />
    <path
      d="M5.41406 10.0005V10.8516H6.31905H7.22404V10.0005V9.14943H6.31905H5.41406V10.0005Z"
      fill="currentColor"
    />
    <path
      d="M5.41406 13.5711V14.4902L6.29643 14.4562L7.16748 14.4221L7.20141 13.537L7.23535 12.6633H6.31905H5.41406V13.5711Z"
      fill="currentColor"
    />
  </svg>
);
